/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowTableRow {
    getFixupPrototypeFunction() { return ServiceNowTableRow.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowTableRow>): ServiceNowTableRow {
        let obj = Object.assign(new ServiceNowTableRow(), model);
        ServiceNowTableRow.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowTableRow>): ServiceNowTableRow {
        if (!model) return null;
        return ServiceNowTableRow.newInstance(<ServiceNowTableRow> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowTableRow) {
        if (!obj) return;

        models.ServiceNowTableRow.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowTableRow): boolean {
        Object.setPrototypeOf(obj, ServiceNowTableRow.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Id of the element
     */
    id: string;

    /**
     * Name of the element
     */
    name: string;

}
